<template>
    <div class="section-FAQ new-faq" :class="background">
        <div class="container">
            <div class="row justify-content-center">
                <div class="title">
                    <h3 class="h1 p-title p-black p-center mb-0 relawayBold">FAQ</h3>
                </div>
            </div>
                    <div class="faq-list">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="faq__item"
                                     v-for="(item, index) in getHalfFaq(1)"
                                     :class="{ 'open' : item.id ===  current_index}"
                                >
                                    <div class="row">

                                        <div class="col-md-12" @click="openFaq(item.id)">

                                            <div class="titles">
                                                <div class="icon" @click="openFaq(item.id)">
                                                    <img src="/img/icon/arrow-down-black.svg" alt="">
                                                </div>
                                                <p class="p-black min-min  mb-0">{{item.id}}{{item.title}}</p>
                                            </div>
                                            <transition name="fade">
                                                <div class="content" v-if="item.id ===  current_index">
                                                    <p class="min-min p-dgrey mb-0">{{item.content}}</p>
                                                </div>
                                            </transition>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="all__faq col-12">
                                <button class="more" @click="openAllFaq()" :class="{'all-open': allFaq}">
                                    <img src="../../../../img/icon/more-plus.svg" alt=""> See more
                                </button>
                            </div>
                            <div class="col-lg-6 second__section" :class="{'allFaq': allFaq}">
                                <div class="faq__item"
                                     v-for="(item, index) in getHalfFaq()"
                                     :class="{ 'open' : item.id ===  current_index}"
                                >
                                    <div class="row">
                                        <div class=" col-md-12" @click="openFaq(item.id)">
                                            <div class="titles">
                                                <div class="icon" @click="openFaq(item.id)">
                                                    <img src="/img/icon/arrow-down-black.svg" alt="">
                                                </div>
                                                <p class="min-min mb-0 p-black ">{{item.id}}{{item.title}}</p>
                                            </div>
                                            <transition name="fade">
                                                <div class="content" v-if="item.id ===  current_index">
                                                    <p class="min-min p-dgrey mb-0">{{item.content}}</p>
                                                </div>
                                            </transition>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


        </div>
    </div>
</template>

<script>
    export default {
        name: "Faq",
        props:[
          'background'
        ],
        data:function () {
            return {
                faq: faq_data,
                current_index: '',
                allFaq: false
            }
        },
        methods: {
            openFaq: function(index){
                console.log(index);

                console.log(this.current_index);

                if(index === this.current_index){
                    this.current_index = '';
                } else {
                    this.current_index = index;
                }
                console.log(this.current_index);
            },
            getHalfFaq(type){
                let count = Math.floor(this.faq.length/2);
                if(type === 1){
                    return this.faq.slice( 0, count + 1);
                } else {
                    return this.faq.slice( count +1)
                }

            },
            openAllFaq(){
                this.allFaq = !this.allFaq
            },
        },


    }
    let faq_data = [
        {
            id: 1,
            title: "Vad gör TecknaEl? ud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute  ud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute ",
            content: "TecknaEl (www.tecknael.se) är en plattform som tillåter besökare att jämföra och byta elavtal. På så vis får både privatpersoner och företag tillgång till ett lättanvänt digitalt verktyg som låter dem hitta det elavtal som passar bäst för dem. Detta kan leda till avsevärda kostnadsbesparingar och assisterar att få fler svenska hushåll att aktivt välja och förstå sitt elavtal."
        },
        {
            id: 2,
            title: "Varför ska man byta elavtal?",
            content: "TecknaEl (www.tecknael.se) är en plattform som tillåter besökare att jämföra och byta elavtal. På så vis får både privatpersoner och företag tillgång till ett lättanvänt digitalt verktyg som låter dem hitta det elavtal som passar bäst för dem. Detta kan leda till avsevärda kostnadsbesparingar och assisterar att få fler svenska hushåll att aktivt välja och förstå sitt elavtal."
        },
        {
            id: 3,
            title: "Varför ska jag byta elavtal med hjälp av TecknaEl?",
            content: "TecknaEl (www.tecknael.se) är en plattform som tillåter besökare att jämföra och byta elavtal. På så vis får både privatpersoner och företag tillgång till ett lättanvänt digitalt verktyg som låter dem hitta det elavtal som passar bäst för dem. Detta kan leda till avsevärda kostnadsbesparingar och assisterar att få fler svenska hushåll att aktivt välja och förstå sitt elavtal."
        },
        {
            id: 4,
            title: "Kan man lita på de elpriser TecknaEl presenterar?",
            content: "TecknaEl (www.tecknael.se) är en plattform som tillåter besökare att jämföra och byta elavtal. På så vis får både privatpersoner och företag tillgång till ett lättanvänt digitalt verktyg som låter dem hitta det elavtal som passar bäst för dem. Detta kan leda till avsevärda kostnadsbesparingar och assisterar att få fler svenska hushåll att aktivt välja och förstå sitt elavtal."
        },
        {
            id: 5,
            title: "Vilka elhandelsbolag finns representerade på TecknaEl?",
            content: "TecknaEl (www.tecknael.se) är en plattform som tillåter besökare att jämföra och byta elavtal. På så vis får både privatpersoner och företag tillgång till ett lättanvänt digitalt verktyg som låter dem hitta det elavtal som passar bäst för dem. Detta kan leda till avsevärda kostnadsbesparingar och assisterar att få fler svenska hushåll att aktivt välja och förstå sitt elavtal."
        },
        {
            id: 6,
            title: "Finns det några risker med att byta elhandelsavtal?",
            content: "TecknaEl (www.tecknael.se) är en plattform som tillåter besökare att jämföra och byta elavtal. På så vis får både privatpersoner och företag tillgång till ett lättanvänt digitalt verktyg som låter dem hitta det elavtal som passar bäst för dem. Detta kan leda till avsevärda kostnadsbesparingar och assisterar att få fler svenska hushåll att aktivt välja och förstå sitt elavtal."
        },
    ]





</script>
